import httpService from "../httpService";

export default {
  findByCaseMasterId(caseMasterId) {
    let params = {caseMasterId: caseMasterId};
    return httpService.get("/hcCongViecTrongTam/findByCaseMasterId", {
      params: params
    });
  },

  findAllByHcCaseCommandsCommonId(hcCongViecTrongTamCommonId) {
    let params = {hcCongViecTrongTamCommonId: hcCongViecTrongTamCommonId};
    return httpService.get("/hcCongViecTrongTam/findAllByHcCongViecTrongTamCommonId", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/hcCongViecTrongTam/${id}`);
  },

  baoCaoChiDao(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/baoCaoChiDao`, form);
  },

  pheDuyet(id) {
    return httpService.put(`/hcCongViecTrongTam/${id}/pheDuyet`);
  },

  yeuCauBoSung(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/yeuCauBoSung`, form);
  },

  giaHan(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/giaHan`, form);
  },

  dangKyDeadline(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/dangKyDeadline`, form);
  },

  huyYeuCau(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/huyYeuCau`, form);
  },

  choYKien(id, form) {
    return httpService.put(`/hcCongViecTrongTam/${id}/choYKien`, form);
  },
};



// WEBPACK FOOTER //
// ./src/services/congviectrongtam/hcCVTrongTamService.js